export var LENS_CATEGORY;
(function (LENS_CATEGORY) {
    LENS_CATEGORY["FOR_YOU"] = "FOR_YOU";
    LENS_CATEGORY["TRENDING"] = "TRENDING";
    LENS_CATEGORY["MUSIC"] = "MUSIC";
    LENS_CATEGORY["FACE"] = "FACE";
    LENS_CATEGORY["WORLD"] = "WORLD";
    LENS_CATEGORY["CREATORS"] = "CREATORS";
    LENS_CATEGORY["WEB_LIVE"] = "WEB_LIVE";
})(LENS_CATEGORY || (LENS_CATEGORY = {}));
